import React, { useContext, useEffect, useState } from 'react';
import HeaderMainFooter from '../templates/HeaderMainFooter';
import { Badge, Box, Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../components/SearchInput';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import ResultsTableOverprice from '../components/ResultsTableOverprice';
import PeriodSelector from '../components/PeriodSelector';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AdvancedFilter from '../components/AdvancedFilter';
import SearchTypeSelector from '../components/SearchTypeSelector';
import Facets from '../components/Facets';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AdvancedFilterOverprice from '../components/AdvancedFilterOverprice';
import SearchInputOverprice from '../components/SearchInputOverprice';
import InfoIcon from '@mui/icons-material/Info';
import AboutOverpriceDialog from '../components/AboutOverpriceDialog';

export const filterMap: any = {
    group_by_description: { label: "Agregação por Descrição", showValue: false },
    group_by_cluster: { label: "Agregação por grupo", showValue: false },
    group_by_first_token: { label: "Agregação por termo relevante", showValue: false },
    group_by_unit_metric: { label: "Agregação por Unidade de Medida", showValue: false },
    group_by_year: { label: "Agregação por ano", showValue: false },
    group_by_overprice: { label: "Efetuar cálculo de sobrepreço", showValue: false },
    min_amount: { label: "Quantidade comprada mínima", showValue: true },
    max_amount: { label: "Quantidade comprada máxima", showValue: true },
    min_cp_price: { label: "Preço de CP mínimo", showValue: true },
    max_cp_price: { label: "Preço de CP maximo", showValue: true },
    min_rf_price: { label: "Preço de RF mínimo", showValue: true },
    max_rf_price: { label: "Preço de RF maximo", showValue: true },
    min_diff_price: { label: "Diferença mínima", showValue: true },
    max_diff_price: { label: "Difereça maxima", showValue: true },
    min_homolog_price: { label: "Preço unitário mínimo", showValue: true },
    max_homolog_price: { label: "Preço unitário maximo", showValue: true },
    body: { label: "Nome do Órgão", showValue: true },
    body_type: { label: "Tipo do Órgão", showValue: true },
    bidder_type: { label: "Tipo de fornecedor", showValue: true },
    bidder_name: { label: "Fornecedor", showValue: true },
    bidder_document: { label: "CNPJ", showValue: true },
    procurement_type: { label: "Licitação", showValue: true },
    modality: { label: "Modalidade", showValue: true },
    object_nature: { label: "Natureza do Objeto", showValue: true },
    city: { label: "Municípios", showValue: true },
    imediate_region: { label: "Região Imediata", showValue: true },
    inter_region: { label: "Região Intermediária", showValue: true },
    year: { label: "Ano", showValue: true },
    month: { label: "Mês", showValue: true },
    after: { label: "Data Inicial", showValue: true },
    before: { label: "Data Final", showValue: true },
    base_cp: { label: "Fonte CP", showValue: true },
    base_rf: { label: "Fonte RF", showValue: true }

}

function ResultsOverprice() {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { userPermissions, setUserPermissions } = useContext(GlobalStateContext);
    const { filtersOverprice, setFiltersOverprice, countFiltersOverprice, cleanFiltersOverprice } = useContext(GlobalStateContext);
    const { typedFiltersOverprice, setTypedFiltersOverprice } = useContext(GlobalStateContext);
    const { typedDescriptionOverprice, setTypedDescriptionOverprice } = useContext(GlobalStateContext);
    const { descriptionOverprice, setDescriptionOverprice } = useContext(GlobalStateContext);
    const { description, setDescription } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);
    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const [openAboutOverprice, setOpenAboutOverprice] = useState(false);
    const navigate = useNavigate();

    const onSearch = (ev: React.FormEvent<HTMLFormElement>) => {
        setDescriptionOverprice(typedDescriptionOverprice);
        setFiltersOverprice(typedFiltersOverprice);
        setSearchType(typedSearchType);
        ev.preventDefault();
    }

    const showTable = () => {
        return <ResultsTableOverprice />
    }

    const convertNumberToMonth = (numbers: number[]) => {
        const monthNames = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];
        let str = ""
        for (let i = 0; i < numbers.length; i++) {
            if (numbers[i] >= 1 && numbers[i] <= 12) {
                str += monthNames[numbers[i] - 1] + ",";
            }
        }
        str = str.replace('undefined,', '');
        return str
    };

    const renderFilters = () => {
        const result: string[] = [];
        const filterArray = Object.entries(filtersOverprice).filter(item => item[1]);

        for (const f of filterArray) {
            const filterMapped = filterMap[f[0]];
            if (filterMapped) {
                let filterResult: string = "";
                f[1] = f[1] + "";
                if (filterMapped.showValue === true && f[1].length > 0) {
                    if (filterMapped.label === "Mês") {
                        filterResult = `${filterMapped.label}: ${convertNumberToMonth(f[1])}`;
                    } else {
                        filterResult = `${filterMapped.label}: ${f[1]}`;
                    }
                    result.push(filterResult);
                }
            }
        }

        if (filtersOverprice.skip_duplicates) {
            result.push("Remover Duplicidades");
        }

        return (
            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                <Box sx={{ maxWidth: '90%' }}>
                    {
                        result.map(item => (
                            <Tooltip title={item} key={item}>
                                <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={item} color="secondary" variant="outlined" size="small" />
                            </Tooltip>
                        ))
                    }
                </Box>
                {result.length > 0 ?
                    <Button sx={{ mr: 4 }} variant='text' color="warning" size='small' startIcon={<HighlightOffIcon />} onClick={cleanFiltersOverprice}>
                        Resetar
                    </Button>
                    : null}
            </Stack>
        );
    }

    useEffect(() => {
        if (userPermissions.usuario === '') {
            navigate('/');
        }
    }, []);

    return (
        <>
            <Box sx={{ height: '100%' }}>
                <HeaderMainFooter />
                <AdvancedFilterOverprice open={showModal} onClose={() => setShowModal(false)} />
                <AboutOverpriceDialog open={openAboutOverprice} onClose={() => setOpenAboutOverprice(false)} />

                <div className="p-2 border-b ">
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', m: 1, mb: 2 }}>
                        <Typography variant="h4" color="primary" textAlign='center'>
                            Sobrepreço pré-calculado
                        </Typography>
                        <IconButton color='primary' size='large' onClick={() => setOpenAboutOverprice(true)}>
                            <InfoIcon />
                        </IconButton>
                    </Box>

                    <form onSubmit={onSearch}>
                        <div className="flex items-center gap-5">
                            <div>
                                <SearchTypeSelector />
                            </div>
                            <div className="flex-1">
                                <SearchInputOverprice />
                            </div>
                            <div className='flex gap-2 items-center w-[650px]'>
                                <PeriodSelector overprice />
                            </div>
                            <div>
                                <Badge badgeContent={countFiltersOverprice()} color="primary">
                                    <Button onClick={() => setShowModal(true)} size='medium'><FilterAltIcon /> Filtro</Button>
                                </Badge>
                            </div>
                            <div>
                                <Button type="submit" variant='contained'>Buscar</Button>
                            </div>
                        </div>
                    </form>
                </div>
                <div className=''>
                    {renderFilters()}
                </div>
                <div className="px-2" style={{ backgroundColor: 'rgb(246 252 252)' }}>
                    <div>
                        {showTable()}
                    </div>
                </div>
            </Box>
        </>
    );
}

export default ResultsOverprice;
